import { createNotification } from "react-redux-notify";
import { put, takeLatest, all } from "redux-saga/effects";

import {
  f2fCallHistoryFailure,
  f2fCallHistorySuccess,
  f2fSessioSuccess,
  f2fSessionFailure,
  f2f_get_single_session_failure,
  f2f_get_single_session_success,
  fetchF2FPendingCallsFailure,
  fetchF2FPendingCallsSuccess
} from "../actions/Face2FaceAction";
import {
  FACE_2_FACE_SESSION,
  FACE_TO_FACE_CALL_HISTORY, FETCH_F2F_PENDING_CALLS_START, GET_SINGLE_SESSION
} from "../actions/ActionConstant";
import api from "../../helpers/services/f2f/api";
import { getErrorNotificationMessage } from "../../components/helper/NotificationMessage";

function* getFace2FaceSession(action) {
  try {
    const response = yield api.getMethod("face2face-calling/calling-history", { params : action.data });
    if (response.data.success) {
      yield put(f2fCallHistorySuccess({
        callHistory: response.data?.result?.result || [],
        pagination: response?.data?.result?.metadata?.pagination || {}
      }));
    } else {
      yield put(f2fCallHistoryFailure(response.data.message));
      const notificationMessage = getErrorNotificationMessage(
        response.data.message
      );

      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(f2fCallHistoryFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.response.data.error[0] || error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* getFace2FaceSingleSession(action) {
  try {
    const response = yield api.getMethod(`face2face-calling/session/${action.data}`);
    if (response.data.success) {
      yield put(f2f_get_single_session_success(response.data));
    } else {
      yield put(f2f_get_single_session_failure(response.data));
      const notificationMessage = getErrorNotificationMessage(
        response.data.message
      );

      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(f2f_get_single_session_failure(error));
    const notificationMessage = getErrorNotificationMessage(error.response.data.error[0] || error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* getFace2FacePendingCalls(action) {
  try {
    const response = yield api.getMethod(`face2face-calling/pending-calls`);
    if (response.data.success) {
      yield put(fetchF2FPendingCallsSuccess(response.data));
    } else {
      yield put(fetchF2FPendingCallsFailure(response.data));
      const notificationMessage = getErrorNotificationMessage(
        response.data.message
      );

      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchF2FPendingCallsFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.response.data.error[0] || error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* getAllFace2FacePendingCallsList(action) {
  try {
    const response = yield api.getMethod(`face2face-calling/call-requests`);
    if (response.data.success) {
      yield put(f2fSessioSuccess(response.data));
    } else {
      yield put(f2fSessionFailure(response.data));
      const notificationMessage = getErrorNotificationMessage(
        response.data.message
      );

      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(f2fSessionFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.response.data.error[0] || error.message);
    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(FACE_TO_FACE_CALL_HISTORY, getFace2FaceSession)]);
  yield all([yield takeLatest(GET_SINGLE_SESSION, getFace2FaceSingleSession)]);
  yield all([yield takeLatest(FETCH_F2F_PENDING_CALLS_START, getFace2FacePendingCalls)]);
  yield all([yield takeLatest(FACE_2_FACE_SESSION, getAllFace2FacePendingCallsList)]);
}
